import React from 'react';
import { Table } from 'antd';
import { useTranslation } from 'react-i18next';
import Helpers from '../../../lib/helpers';
import SectionWrapper from '../../Dispute/SectionWrapper';
import { useGetOrderPaymentSummaryQuery } from '../../../store/services/disputeService';
import { useParams } from 'react-router-dom';

export default function OrderPaymentSummary() {
  const { t } = useTranslation();
  const params = useParams();

  const { data: orderPaymentSummary } = useGetOrderPaymentSummaryQuery(
    { disputeId: params?.disputeId },
    {
      refetchOnMountOrArgChange: true,
    }
  );

  const columns = [
    { title: '', dataIndex: 'name', key: 'name' },
    {
      title: '',
      dataIndex: 'value',
      key: 'value',
      className: 'text-end font-semibold',
    },
  ];
  const paymentSummary = [
    {
      name: t('components.disputeFeature.totalCost'),
      value: Helpers.formatMoney(orderPaymentSummary?.payload?.totalCost),
    },
    {
      name: t('components.disputeFeature.transactionId'),
      value: orderPaymentSummary?.payload?.transactionId,
    },
    {
      name: t('components.disputeFeature.paymentMethod'),
      value: orderPaymentSummary?.payload?.paymentMethod?.method,
    },
  ];

  return (
    <SectionWrapper title={t('components.disputeFeature.orderPaymentSummary')}>
      <Table
        columns={columns}
        className="customTable"
        dataSource={paymentSummary}
        pagination={false}
        showHeader={false}
        size="middle"
      />
    </SectionWrapper>
  );
}
